import type { Time } from "@/lib/time"

export const toEpochMilliseconds = (
  input: Date | number | string
): Time.EpochMilliseconds => {
  if (typeof input === `object`) {
    return input.getTime()
  }

  if (typeof input === `string`) {
    return new Date(input).getTime()
  }

  return input
}
